import React from 'react';
import { Button, Form, FormGroup, FormInput } from 'shards-react';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

interface NewPasswordFormProps {
  password1: string;
  password2: string;
  isValid: boolean;
  isLoading: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.SyntheticEvent<HTMLFormElement>) => void;
}

const NewPasswordForm = ({ password1, password2, isValid, isLoading, handleChange, handleSubmit }: NewPasswordFormProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <p>{t('login.reset.require')}</p>
          <small className="mb-3 p-3 form-text border rounded bg-light">
            {t('login.reset.terms')}
            <ul className="my-1 pl-4">
              <li>{t('login.reset.term1')}</li>
              <li>{t('login.reset.term2')}</li>
              <li>{t('login.reset.term3')}</li>
              <li>{t('login.reset.term4')}</li>
            </ul>
          </small>
          <label htmlFor="password1">{t('login.reset.newPassword')}</label>
          <FormInput type="password" id="password1" autoComplete="new-password" placeholder={t('login.reset.enterNewPassword')} value={password1} onChange={handleChange} disabled={isLoading} />
        </FormGroup>
        <FormGroup>
          <FormInput type="password" id="password2" autoComplete="new-password" placeholder={t('login.reset.confirmNewPassword')} value={password2} onChange={handleChange} disabled={isLoading} />
        </FormGroup>
        <Button pill theme="accent" className="d-table mx-auto" type="submit" disabled={!isValid || isLoading}>
          {isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />}
          {t('login.reset.change')}
        </Button>
      </Form>
    </>
  );
};

export default NewPasswordForm;
